
import { appApi } from '../../../store/app.api';
import { appEndpoint } from '../../../store/app.endpoint';
import { CommandRequest } from '../../../libs/auth/utilities/command-request';

export const unitsApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    getUnits: build.query<any, void>({
      query: () => ({
        url: appEndpoint.units,
        method: 'get',
      }),
      providesTags: ['Units'],
    }),
    addUnit: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: appEndpoint.units,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["Units"] : []),
    }),

    updateUnit: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.units}/${data.id}?_method=put`,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["Units"] : []),
    }),
    
    getUnitById: build.query<any, string>({
      query: (id) => ({
        url: `${appEndpoint.units}/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [{ type: 'Units', id }],
    }),

    deleteUnit: build.mutation<void, string>({
      query: (id) => ({
        url: `${appEndpoint.units}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['Units'],
    }),

  }),
  overrideExisting: false,
});

export const {
  useGetUnitsQuery,
  useGetUnitByIdQuery,
  useDeleteUnitMutation,
  useUpdateUnitMutation,
  useAddUnitMutation
} = unitsApi;